import React from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate, useLocation } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";

import Landing from "@/pages/Landing";
import Dashboard from "@/pages/Dashboard";
import NewTender from "@/pages/NewTender";
import TenderDetail from "@/pages/TenderDetail";
import Login from "@/pages/Login";
import CompanyProfile from "@/pages/CompanyProfile";
import Analytics from "@/pages/Analytics";
import Calendar from "@/pages/Calendar";
import Plcsp from "@/pages/Plcsp";
import CumplimentarAnexos from "@/pages/CumplimentarAnexos";
import MemoriaStandalone from "@/pages/MemoriaStandalone";
import Crm from "@/pages/Crm";
import Competidores from "@/pages/Competidores";
import Alerts from "@/pages/Alerts";
import Contacts from "@/pages/Contacts";
import Customers from "@/pages/Customers";
import Legal from "@/pages/Legal";
import Users from "@/pages/Users";
import Licitaciones from "@/pages/Licitaciones";
import Auditoria from "@/pages/Auditoria";
import Seguridad from "@/pages/Seguridad";
import Solvencia from "@/pages/Solvencia";
import MiDocumentacion from "@/pages/MiDocumentacion";
import Comunicaciones from "@/pages/Comunicaciones";
import Seguimiento from "@/pages/Seguimiento";
import Visitas from "@/pages/Visitas";
import Cobertura from "@/pages/Cobertura";
import BusquedasGuardadas from "@/pages/BusquedasGuardadas";
import { AuthProvider } from "@/context/AuthContext";
import ProtectedRoute from "@/components/ProtectedRoute";
import { trackPageview } from "@/lib/tracker";
import { WelcomeTourBootstrap } from "@/components/WelcomeTour";

function TrackerListener() {
    const location = useLocation();
    React.useEffect(() => {
        // Anonymize tender / customer IDs in path to avoid leaking ids in metrics
        const clean = location.pathname.replace(
            /(\/licitacion\/|\/clientes\/|\/legal\/|\/seguimiento\/)[^/?#]+/i,
            "$1:id",
        );
        trackPageview(clean);
    }, [location.pathname]);
    return null;
}

function AppRouter() {
    return (
        <>
            <TrackerListener />
            <WelcomeTourBootstrap />
            <Routes>
                <Route path="/" element={<Landing />} />
                <Route path="/login" element={<Login />} />
            <Route
                path="/app"
                element={
                    <ProtectedRoute>
                        <Dashboard />
                    </ProtectedRoute>
                }
            />
            <Route
                path="/app/nueva"
                element={
                    <ProtectedRoute>
                        <NewTender />
                    </ProtectedRoute>
                }
            />
            <Route
                path="/app/licitacion/:id"
                element={
                    <ProtectedRoute>
                        <TenderDetail />
                    </ProtectedRoute>
                }
            />
            <Route
                path="/app/perfil-empresa"
                element={
                    <ProtectedRoute>
                        <CompanyProfile />
                    </ProtectedRoute>
                }
            />
            <Route
                path="/app/analiticas"
                element={
                    <ProtectedRoute>
                        <Analytics />
                    </ProtectedRoute>
                }
            />
            <Route
                path="/app/calendario"
                element={
                    <ProtectedRoute>
                        <Calendar />
                    </ProtectedRoute>
                }
            />
            <Route
                path="/app/buscar-plcsp"
                element={
                    <ProtectedRoute>
                        <Plcsp />
                    </ProtectedRoute>
                }
            />
            <Route
                path="/app/cumplimentar-anexos"
                element={
                    <ProtectedRoute>
                        <CumplimentarAnexos />
                    </ProtectedRoute>
                }
            />
            <Route
                path="/app/memoria-tecnica"
                element={
                    <ProtectedRoute>
                        <MemoriaStandalone />
                    </ProtectedRoute>
                }
            />
            <Route
                path="/app/solvencia"
                element={
                    <ProtectedRoute>
                        <Solvencia />
                    </ProtectedRoute>
                }
            />
            <Route
                path="/app/mi-documentacion"
                element={
                    <ProtectedRoute>
                        <MiDocumentacion />
                    </ProtectedRoute>
                }
            />
            <Route
                path="/app/comunicaciones"
                element={
                    <ProtectedRoute>
                        <Comunicaciones />
                    </ProtectedRoute>
                }
            />
            <Route
                path="/app/alertas"
                element={
                    <ProtectedRoute>
                        <Alerts />
                    </ProtectedRoute>
                }
            />
            <Route
                path="/app/competidores"
                element={
                    <ProtectedRoute>
                        <Competidores />
                    </ProtectedRoute>
                }
            />
            <Route
                path="/app/contactos"
                element={
                    <ProtectedRoute>
                        <Contacts />
                    </ProtectedRoute>
                }
            />
            <Route
                path="/app/clientes"
                element={
                    <ProtectedRoute>
                        <Customers />
                    </ProtectedRoute>
                }
            />
            <Route
                path="/app/legal"
                element={
                    <ProtectedRoute>
                        <Legal />
                    </ProtectedRoute>
                }
            />
            <Route
                path="/app/seguimiento"
                element={
                    <ProtectedRoute>
                        <Seguimiento />
                    </ProtectedRoute>
                }
            />
            <Route
                path="/app/usuarios"
                element={
                    <ProtectedRoute>
                        <Users />
                    </ProtectedRoute>
                }
            />
            <Route
                path="/app/licitaciones"
                element={
                    <ProtectedRoute>
                        <Licitaciones />
                    </ProtectedRoute>
                }
            />
            <Route
                path="/app/crm"
                element={
                    <ProtectedRoute>
                        <Crm />
                    </ProtectedRoute>
                }
            />
            <Route
                path="/app/auditoria"
                element={
                    <ProtectedRoute>
                        <Auditoria />
                    </ProtectedRoute>
                }
            />
            <Route
                path="/app/seguridad"
                element={
                    <ProtectedRoute>
                        <Seguridad />
                    </ProtectedRoute>
                }
            />
            <Route
                path="/app/visitas"
                element={
                    <ProtectedRoute>
                        <Visitas />
                    </ProtectedRoute>
                }
            />
            <Route
                path="/app/cobertura"
                element={
                    <ProtectedRoute>
                        <Cobertura />
                    </ProtectedRoute>
                }
            />
            <Route
                path="/app/busquedas-guardadas"
                element={
                    <ProtectedRoute>
                        <BusquedasGuardadas />
                    </ProtectedRoute>
                }
            />
            <Route path="*" element={<Navigate to="/" replace />} />
        </Routes>
        </>
    );
}

function App() {
    return (
        <div className="App">
            <BrowserRouter>
                <AuthProvider>
                    <AppRouter />
                </AuthProvider>
            </BrowserRouter>
            <Toaster position="top-right" richColors closeButton />
        </div>
    );
}

export default App;
